
import { equals, createObj, int32ToString } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { join, concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { map, toArray, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.0.0-rc.2/Range.js";
import { item, tryFindIndex } from "../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { ActivityPanel } from "./Types.js";
import Bell_Notification from "../../public/assets/icons/Bell_Notification.svg";
import Chat_Bubble from "../../public/assets/icons/Chat_Bubble.svg";
import Help_Chat_2 from "../../public/assets/icons/Help_Chat_2.svg";
import Question_Circle from "../../public/assets/icons/Question_Circle.svg";

function countLabel(count) {
    if (count > 9) {
        return "9+";
    }
    else {
        return int32ToString(count);
    }
}

function RailButton(props) {
    let arg_1, elems_1;
    const patternInput = useTranslation();
    const tooltip = (props.Count > 0) ? (concat(props.Label, ..." · ") + ((arg_1 = {
        count: props.Count,
    }, patternInput[1].t("activity_bar.unread_count", arg_1)))) : props.Label;
    return reactElement("button", createObj(ofArray([["type", "button"], ["data-test-id", props.TestId], ["data-count", int32ToString(props.Count)], ["aria-pressed", props.IsActive], ["aria-label", tooltip], ["title", tooltip], ["className", join(" ", toList(delay(() => append(singleton("relative"), delay(() => append(singleton("flex"), delay(() => append(singleton("flex-col"), delay(() => append(singleton("items-center"), delay(() => append(singleton("justify-center"), delay(() => append(singleton("gap-[3px]"), delay(() => append(singleton("h-10"), delay(() => append(singleton("w-10"), delay(() => append(singleton("lg:h-14"), delay(() => append(singleton("lg:w-14"), delay(() => append(singleton("rounded-[10px]"), delay(() => append(singleton("text-[10px]"), delay(() => append(singleton("font-medium"), delay(() => append(singleton("cursor-pointer"), delay(() => append(singleton("focus-visible:outline"), delay(() => append(singleton("focus-visible:outline-2"), delay(() => append(singleton("focus-visible:outline-offset-2"), delay(() => append(singleton("focus-visible:outline-primary"), delay(() => append(singleton("text-black"), delay(() => (props.IsActive ? singleton("bg-background") : singleton("hover:bg-background")))))))))))))))))))))))))))))))))))))))))))], ["onClick", (_arg) => {
        props.OnClick();
    }], (elems_1 = toList(delay(() => append(singleton(reactElement("div", {
        className: join(" ", ["h-[22px]", "w-[22px]"]),
        children: reactApi.Children.toArray([props.Icon]),
    })), delay(() => append(singleton(reactElement("span", {
        className: join(" ", ["hidden", "lg:block"]),
        children: props.Label,
    })), delay(() => (((props.Count > 0) && !props.IsActive) ? singleton(reactElement("span", {
        "data-test-id": concat(props.TestId, ..."-count"),
        className: join(" ", ["absolute", "top-0", "right-0", "lg:top-1", "lg:right-1.5", "min-w-[16px]", "h-4", "px-1", "rounded-full", "bg-red", "text-white", "text-[10px]", "font-semibold", "flex", "items-center", "justify-center"]),
        children: countLabel(props.Count),
    })) : empty()))))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function moveFocus(container, direction) {
    let index_1;
    const buttons = container.querySelectorAll("button");
    const elements = toArray(delay(() => map((index) => (buttons[index]), rangeDouble(0, 1, buttons.length - 1))));
    const activeIndex = tryFindIndex((element) => equals(element, document.activeElement), elements);
    let matchResult, index_2;
    if (activeIndex != null) {
        if ((index_1 = (activeIndex | 0), elements.length > 0)) {
            matchResult = 0;
            index_2 = activeIndex;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const next = (((index_2 + direction) + elements.length) % elements.length) | 0;
            item(next, elements).focus();
            break;
        }
        case 1: {
            break;
        }
    }
}

export function ActivityRail(props) {
    let elems;
    const t = useTranslation()[0];
    const button = (panel, icon, label, count, testId) => createElement(RailButton, {
        Count: count,
        Icon: icon,
        IsActive: equals(props.ActivePanel, panel),
        Label: label,
        OnClick: () => {
            props.OnSelect(panel);
        },
        Panel: panel,
        TestId: testId,
    });
    return reactElement("nav", createObj(ofArray([["data-test-id", "activity-rail"], ["aria-label", t("activity_bar.title")], ["className", join(" ", ["row-start-1", "row-span-2", "col-start-5", "relative", "z-[18]", "h-screen", "w-14", "lg:w-[72px]", "bg-white", "border-l-[2px]", "border-border", "flex", "flex-col", "items-center", "gap-2", "pt-3", "print:hidden"])], ["onKeyDown", (event) => {
        const matchValue = event.key;
        switch (matchValue) {
            case "ArrowDown": {
                event.preventDefault();
                moveFocus(event.currentTarget, 1);
                break;
            }
            case "ArrowUp": {
                event.preventDefault();
                moveFocus(event.currentTarget, -1);
                break;
            }
            case "Escape": {
                props.OnClose();
                break;
            }
            default:
                undefined;
        }
    }], (elems = toList(delay(() => append(singleton(button(new ActivityPanel(0, []), Bell_Notification(), t("activity_bar.notifications"), props.NotificationCount, "activity-rail-notifications")), delay(() => append(props.ShowChat ? singleton(button(new ActivityPanel(1, []), Chat_Bubble(), t("activity_bar.chat"), props.ChatUnreadCount, "activity-rail-chat")) : empty(), delay(() => append(props.ShowSupport ? singleton(button(new ActivityPanel(2, []), Help_Chat_2(), t("activity_bar.support"), props.SupportUnreadCount, "activity-rail-support")) : empty(), delay(() => (props.ShowHelp ? singleton(button(new ActivityPanel(3, []), Question_Circle(), t("activity_bar.help"), 0, "activity-rail-help")) : empty()))))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

